import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';

class MessageModal extends React.Component {

  render() {
    const parcels = [];
    this.props.messageText.map((i, y) => (parcels.push(i)));
    const parcelsText = parcels.join('; ');
    return (
      <Modal show={this.props.openModal} onHide={this.props.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Komunikat błędu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.message === 1 ?
          <h4>Wybrano działkę, która nie istnieje badź leży poza terenem gminy</h4>
          :
          <text>
            <h4>Poniższe działki nie mają pokrycia w MPZP:</h4>
            <i style={{ textAlign: 'justify' }}>{parcelsText}</i>
          </text>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.closeModal}>Zamknij</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
MessageModal.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default MessageModal;



// WEBPACK FOOTER //
// src/routes/eservices/MessageModal.js